import SimpleApiKeySection from "./SimpleApiKeySection";
import BedrockSection from "./BedrockSection";
import AzureSection from "./AzureSection";
import VertexAISection from "./VertexAISection";

export const APIKeysSection = ({
  provider,
  onAfterProviderKeySaved,
}: {
  provider: string;
  onAfterProviderKeySaved?: () => void;
}) => {
  switch (provider) {
    case "openai":
      return (
        <SimpleApiKeySection
          title="OpenAI API Key"
          provider="openai"
          placeholder="sk-xxxxxxxxxxx"
          onAfterSaveSuccess={onAfterProviderKeySaved}
        />
      );
    case "anthropic":
      return (
        <SimpleApiKeySection
          title="Anthropic API Key"
          provider="anthropic"
          placeholder="sk-xxxxxxxxxxx"
          onAfterSaveSuccess={onAfterProviderKeySaved}
        />
      );
    case "cohere":
      return (
        <SimpleApiKeySection
          title="Cohere API Key"
          provider="cohere"
          placeholder="sk-xxxxxxxxxxx"
          onAfterSaveSuccess={onAfterProviderKeySaved}
        />
      );
    case "mistral":
      return (
        <SimpleApiKeySection
          title="Mistral API Key"
          provider="mistral"
          placeholder="xxxxxxxxxxx"
          onAfterSaveSuccess={onAfterProviderKeySaved}
        />
      );
    case "google":
      return (
        <SimpleApiKeySection
          title="Google API Key"
          provider="google"
          placeholder="sk-xxxxxxxxxxx"
          onAfterSaveSuccess={onAfterProviderKeySaved}
        />
      );
    case "openrouter":
      return (
        <SimpleApiKeySection
          title="OpenRouter API Key"
          provider="openrouter"
          placeholder="sk-or-xxxxxxxxxxx"
          onAfterSaveSuccess={onAfterProviderKeySaved}
        />
      );
    case "bedrock":
      return <BedrockSection onAfterSaveSuccess={onAfterProviderKeySaved} />;
    case "azure":
      return <AzureSection onAfterSaveSuccess={onAfterProviderKeySaved} />;
    case "vertexai":
      return <VertexAISection onAfterSaveSuccess={onAfterProviderKeySaved} />;
    default:
      return null;
  }
};
